module.exports = "<ng-container *ngIf=\"content$ | async as content\">    \n    <vdgm-date-picker class=\"date-picker\" [locked]=\"true\" [selectedValue]=\"selectedDate\" (onChange)=\"onDateChanged($event)\" [style.z-index]=\"zIndex\"></vdgm-date-picker>\n    <div class=\"selected-item\" *ngIf=\"selectedItem; let item\">\n        <lazy-item-list [list]=\"item\" [paginate]=\"paginate\" [config]=\"config\"></lazy-item-list>\n    </div>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/list/date-select-list/date-select-list.template.html
// module id = 766
// module chunks = 2